import { COMPONENT_VALUE_TYPES as types, THREE_POSITION_LAYOUTS } from 'shared/constants';

const propsSchema = [
  {
    key: 'thickness',
    label: 'Thickness (px)',
    type: types.TEXT
  },
  {
    key: 'length',
    label: 'Length (%)',
    type: types.TEXT
  },
  {
    key: 'margin',
    label: 'Margin',
    type: types.TEXT
  },
  {
    key: 'position',
    label: 'Position (left/central/right)',
    type: types.ENUM,
    options: THREE_POSITION_LAYOUTS
  },
  {
    key: 'color',
    label: 'Color',
    type: types.COLOR_PICKER
  }
];

const defaultProps = {
  thickness: '3',
  length: '80',
  margin: '36px 0px',
  position: 'LEFT',
  color: 'Red',
};

export default {
  title: 'Generic Separator',
  id: 'GenericSeparator',
  widgetImage: `/widgetImages/Generic_Separator.png`,
  basic: true,
  propsSchema,
  defaultProps
};
